import React, {useEffect, useState} from 'react';
import {Head} from "../../components";
import {CircularProgress, Paper} from "@mui/material";
import Container from "@mui/material/Container";
import IconButton from "@mui/material/IconButton";
import SyncIcon from '@mui/icons-material/Sync';
import {Box, Tooltip} from "@mui/material";
import moment from 'moment-jalaali'
import './style.css'
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Divider from '@mui/material/Divider';
import Button from '@mui/material/Button';
import DeleteIcon from '@mui/icons-material/Delete';
import Api from "../../utils/api";
import {toast} from "react-toastify";
import SupplierCreate from "../../components/Supplier/create";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionActions from "@mui/material/AccordionActions";

const Supplier = () => {

    const [suppliers,setSuppliers] = useState('')
    const [typingTimeout, setTypingTimeout] = useState(0);
    const [isSearching,setIsSearching] = useState(false)
    const instance = new Api();


    useEffect(() => {
        getSupplier();
    }, [])

    const handleChangeSearchInput = (event) => {
        let val = event.target.value;

        setIsSearching(true)
        if (typingTimeout) {
            clearTimeout(typingTimeout);
        }
        if (val && val.length > 0) {
            let loop = setTimeout(async () => {
                await new Promise(resolve => {
                    resolve(instance.get(`/products/supplier/autocomplete/${val}`).then((response) => {
                        if (typeof response != "undefined") {
                            if (!response.status || response.details.length <= 0) {
                                toast.error('موردی یافت نشد');
                                setIsSearching(false)
                            }else {
                                setSuppliers(response.details);
                                setIsSearching(false)
                            }
                        }
                    }));
                })
            }, 500);

            setTypingTimeout(loop);
        } else {
            getSupplier()
            setIsSearching(false)
        }
    }




    const getSupplier = () => {
        new Api().get('/products/supplier').then((response) => {
            if (typeof response !== "undefined") {
                if(!response.status) {
                    toast.error('توی لود تامیین کننده مشکلی به وجود آمده');
                }else {
                    setSuppliers(response.details);
                }
            }else {
                toast.error('توی لود تامیین کننده مشکلی به وجود آمده');
            }
        })
    }

    const deleteSupplier = (id) => {

        new Api().delete(`/products/supplier/destroy/${id}`).then((response) => {
            if (typeof response !== "undefined") {
                if (response.status) {
                    toast.success(response.msg);
                    getSupplier()
                } else {
                    toast.error(response.msg);
                }
            }
        })
    }

    return(
        <Container>
            <Head data={{ 'link': '/', 'title': 'مدیریت تامیین کننده ها', 'description': 'تامیین کننده ها را مدیریت کنید' }} />
            <Box mb={5}>
                <Accordion>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1c-content"
                        id="panel1c-header"
                    >
                        <div>
                            <Typography>جستجو در لیست</Typography>
                        </div>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Grid container spacing={2} alignItems="center">
                            <Grid item xs={12} sm={4} md={3}>
                                <TextField
                                    id="outlined-name"
                                    label="نام تامین کننده"
                                    variant="outlined"
                                    margin="dense"
                                    fullWidth
                                    name="name"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={handleChangeSearchInput}
                                />
                            </Grid>
                            {isSearching && <CircularProgress style={{ width: 24, height: 24 }} />}
                        </Grid>
                    </AccordionDetails>
                    <Divider />
                    <AccordionActions>
                        <Button color="primary">جستجو</Button>
                    </AccordionActions>
                </Accordion>

            </Box>
            <div style={{ display: 'flex', direction: 'row', justifyContent: 'flex-end'}}>
                {<SupplierCreate/>}
                <Tooltip title="سینک" onClick={() => getSupplier()}>
                    <IconButton>
                        <SyncIcon />
                    </IconButton>
                </Tooltip>
            </div>
            <>
                <div style={{ overflowX: 'auto'}}>
                    <table className='table'>
                        <thead>
                        <tr>
                            <th>#</th>
                            <th>نام تامین کننده</th>
                            <th>تاریخ ثبت </th>
                            <th>عملیات</th>
                        </tr>
                        </thead>
                        <tbody>
                        {suppliers && suppliers.map((supplier, index) => {
                            return(
                                <tr key={index}>
                                    <td>{supplier.id}</td>
                                    <td>{supplier.name }</td>
                                    <td style={{ direction: 'ltr'}}>{moment(supplier.created_at).locale('fa').format('jYYYY/jMM/jDD HH:mm:ss')}</td>
                                    <td style={{ display:'flex', 'direction': 'row', justifyContent: 'center', alignItems: 'center'}}>
                                        <div onClick={()=>deleteSupplier(supplier.id)}  style={{ display:'flex', justifyContent: 'center', alignItems: 'center'}}>
                                            <DeleteIcon style={{ fontSize: 24 }}/>
                                        </div>
                                    </td>
                                </tr>
                            );
                        })}
                        </tbody>
                    </table>
                </div>
            </>
        </Container>

    );
}


export default Supplier
